const getBrightness = (colorCode: string) => {
  const r = parseInt(colorCode.substring(1, 3), 16);
  const g = parseInt(colorCode.substring(3, 5), 16);
  const b = parseInt(colorCode.substring(5, 7), 16);

  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

export const checkColorBrightness = ({
  backgroundColor = '',
  textColor
}: {
  backgroundColor: string;
  textColor?: string;
}) => {
  const background = getBrightness(backgroundColor);
  const text = getBrightness(textColor ?? '#000000');

  const bigInt = background > text ? background : text;
  const smallInt = background < text ? background : text;

  if ((background < 128 && background === text) || bigInt - smallInt < 20) {
    return text > 128 ? '#000000' : '#FFFFFF';
  }

  if (textColor) {
    return textColor;
  }

  if (background < 128) {
    return '#FFFFFF';
  }
  return '#000000';
};

export const getContrastingColor = (color: string): string => {
  let rgbColor: string | undefined;
  if (color.startsWith('#')) {
    const hex = color.slice(1);
    rgbColor = `rgb(${parseInt(hex.slice(0, 2), 16)}, ${parseInt(hex.slice(2, 4), 16)}, ${parseInt(
      hex.slice(4, 6),
      16
    )})`;
  } else if (color.startsWith('rgb')) {
    rgbColor = color;
  } else if (color.startsWith('rgba')) {
    const rgbaArr = color.replace(/[^\d,.]/g, '').split(',');
    rgbColor = `rgb(${rgbaArr[0]}, ${rgbaArr[1]}, ${rgbaArr[2]})`;
  } else {
    console.error('Unsupported color format');
  }

  const [r, g, b] = rgbColor?.match(/\d+/g)?.map(Number) as number[];
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness >= 128 ? 'black' : color;
};
